import React from "react";
import { Button } from "@backslashbuild/pp-ui";
import { usePost } from "./api";
import { publish } from "../../pubSub";

export default function CreateInvoiceIndexButton() {
  const reset = usePost("invoices/index/create");

  async function handleCreateIndex() {
    publish("notification", "Creating the invoice index...");
    const result = await reset();

    if (!result.isSuccess) {
      var errors = result?.errors;
      publish(
        "notification",
        <ul>
          Unable to create invoice index. Errors:
          {errors?.length > 0 &&
            errors?.map((error) => {
              return <li>{error}</li>;
            })}
        </ul>
      );
      return;
    }

    if (result?.isSuccess) publish("notification", "Index creation completed.");
  }

  return (
    <>
      <Button small onClick={() => handleCreateIndex()} style={{ width: 200 }}>
        Create Invoice Index
      </Button>
    </>
  );
}
